import type { FC, ReactNode } from 'react';
import { createContext, useContext } from 'react';

import { Outlet } from '@luna/router';

type TransactionAccountId = string;

const context = createContext<TransactionAccountId | undefined>(undefined);

export const TransactionAccountIdProvider: FC<{
    id?: TransactionAccountId;
    children?: ReactNode;
}> = ({ id, children = <Outlet /> }) => <context.Provider value={id}>{children}</context.Provider>;

/**
 * The id of a Product. This id can be used to identify the Product when talking
 * to Backend Services.
 *
 * For Card Products, this id will be a compound ID of the Card's Backing
 * Account and the Card id itself: {BACKING_ACCOUNT_ID}-{CARD_ID}.
 *
 * Cards Products have a Backing Account against which transactions are
 * recorded. A Backing Account Product can be associated with many Card
 * Products. But a Card Product can only have one Backing Account.
 *
 * MBS accounts may also be in kebab case, but unlike with Card Products, the
 * hyphen does not delimit anything meaningful in George.
 */
export const useTransactionAccountIdFromContext = () => useContext(context);
